import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/app");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="hidden border-r border-slate-200 bg-slate-950 lg:block">
        <div className="flex h-full flex-col justify-between p-12 text-slate-200">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <div className="grid h-7 w-7 place-items-center rounded-md bg-white text-slate-900">
              <span className="font-display text-sm font-bold">T</span>
            </div>
            <span className="font-display text-lg font-semibold tracking-tight text-white">Toastern</span>
          </Link>
          <div>
            <p className="font-mono-tight text-xs uppercase tracking-widest text-slate-500">// today</p>
            <h2 className="mt-3 font-display text-3xl font-semibold text-white">
              Ship cloud projects that already respect your rules.
            </h2>
            <p className="mt-4 max-w-md text-sm text-slate-400">
              Codify your governance once. Toastern turns it into ready-to-deploy Terraform and
              Bicep projects for Azure and AWS.
            </p>
          </div>
          <p className="font-mono-tight text-[11px] text-slate-600">
            &quot;terraform init · terraform apply&quot;
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="login-form">
          <div>
            <p className="font-mono-tight text-xs uppercase tracking-widest text-slate-500">// sign in</p>
            <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight">Welcome back</h1>
            <p className="mt-2 text-sm text-slate-600">
              Use your Toastern workspace credentials.
            </p>
          </div>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-widest text-slate-500">Email</Label>
              <Input
                id="email"
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 h-10 border-slate-200"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-widest text-slate-500">Password</Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 h-10 border-slate-200"
                required
              />
            </div>
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="h-11 w-full rounded-md bg-slate-900 text-white hover:bg-slate-800"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <p className="text-center text-sm text-slate-600">
            No account yet?{" "}
            <Link to="/register" className="text-slate-900 underline" data-testid="link-register">
              Create one
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
